import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Stethoscope } from 'lucide-react';

/**
 * Enveloppe publique (hors authentification) pour les pages du blog documentaire.
 * En-tête de marque + CTA vers l'outil + pied de page légal léger.
 */
export const BlogLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 flex flex-col font-[Inter,system-ui,sans-serif]">
      {/* En-tête */}
      <header className="sticky top-0 z-30 border-b border-slate-800/80 bg-slate-950/85 backdrop-blur-md">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <Link to="/blog" data-testid="blog-home-link" className="flex items-center gap-2.5 group min-w-0">
            <img src="/logo.png" alt="Hippocrate MG" className="w-9 h-9 rounded-lg shrink-0" />
            <span className="flex flex-col leading-none min-w-0">
              <span className="font-semibold text-white truncate" style={{ fontFamily: 'Outfit, Manrope, system-ui, sans-serif' }}>
                Hippocrate MG
              </span>
              <span className="text-[11px] text-indigo-300/80 truncate">Fiches documentaires</span>
            </span>
          </Link>
          <Link
            to="/login"
            data-testid="blog-cta-app"
            className="inline-flex items-center gap-1.5 rounded-full bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium px-4 py-2 min-h-[40px] transition-colors"
          >
            Accéder à l'outil
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </header>

      <main className="flex-1 w-full">{children}</main>

      {/* Pied de page */}
      <footer className="border-t border-slate-800/80 bg-slate-950 mt-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 space-y-4">
          <div className="flex items-start gap-2 text-xs text-slate-400 leading-relaxed">
            <Stethoscope className="w-4 h-4 mt-0.5 shrink-0 text-slate-500" />
            <p>
              Contenu <strong className="text-slate-300 font-medium">documentaire</strong> destiné aux professionnels de santé.
              Il ne constitue pas un dispositif médical, ni un avis médical personnalisé, et ne remplace pas une consultation.
              Vérifiez toujours les informations sur les sources officielles citées.
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-slate-400">
            <Link to="/login" className="hover:text-indigo-300" data-testid="blog-footer-login">Connexion</Link>
            <Link to="/mentions-legales" className="hover:text-indigo-300">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-indigo-300">Confidentialité</Link>
            <span className="text-slate-600">© {new Date().getFullYear()} Hippocrate MG</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BlogLayout;
